import type { ListBuilderList } from '../../../types';
import { createActivityListColumns } from '../columns';
import {
	ACTIVITY_LIST_ACTIVE_FILTERS,
	ACTIVITY_LIST_REQUIRED_FIELDS,
	CLIENT_MOBILE_CARD_CONFIG,
	SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
	createClientKanbanConfig,
} from '../shared';

/**
 * Overdue list configuration
 * Clients with overdue activities, sorted by activity time
 */
export const overdueList: ListBuilderList = {
	id: 'overdue-list',
	cacheTTL: 300000,
	name: 'Overdue',
	type: 'default',
	active: true,
	columns: createActivityListColumns(),
	mobileCardConfig: CLIENT_MOBILE_CARD_CONFIG,
	description: 'Clients with overdue activities, sorted by activity time',
	defaultSortId: 'next-activity-asc',
	requiredFields: ACTIVITY_LIST_REQUIRED_FIELDS,
	activeFilters: ACTIVITY_LIST_ACTIVE_FILTERS,
	sortOrder: 2,
	filterRules: {
		...SALESPEOPLE_FILTER_RULES_SELF_DEFAULT,
		callStatus: {
			defaultValue: [
				{
					id: 'Callable',
					label: 'Callable',
				},
			],
		},
		specialFilters: {
			defaultValue: [
				{
					id: 'overdue',
					label: 'Overdue',
				},
			],
		},
	},
	kanbanConfig: createClientKanbanConfig(),
};
